'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import { cn } from '@workspace/ui/lib';
import { useState } from 'react';

interface NpsRatingProps {
  onSubmit: (rating: number) => void;
  isSubmitting?: boolean;
  loadingText: string;
}

export function NpsRating({ onSubmit, isSubmitting = false, loadingText }: NpsRatingProps) {
  const [selectedRating, setSelectedRating] = useState<number | null>(null);
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  const handleSubmit = () => {
    if (selectedRating !== null) {
      onSubmit(selectedRating);
    }
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h3 className="text-xl font-bold text-neutral-200 dark:text-neutral-100">
          How likely are you to recommend us?
        </h3>
        <p className="text-grey-600 dark:text-grey-400 text-sm">
          On a scale of 1 to 10, how likely are you to recommend our platform to a friend or
          colleague?
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex gap-1.5">
          {Array.from({ length: 10 }, (_, i) => i + 1).map((rating) => {
            const isSelected = selectedRating === rating;
            const isHovered = hoveredRating === rating;

            return (
              <button
                key={rating}
                type="button"
                disabled={isSubmitting}
                onClick={() => setSelectedRating(rating)}
                onMouseEnter={() => setHoveredRating(rating)}
                onMouseLeave={() => setHoveredRating(null)}
                className={cn(
                  'flex h-10 w-full items-center justify-center rounded-xl border text-sm font-medium transition-all',
                  'cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
                  isSelected
                    ? 'border-pink-400 bg-pink-400 text-neutral-100'
                    : isHovered
                      ? 'border-pink-300 bg-pink-50 text-pink-500 dark:bg-pink-400/10 dark:text-pink-300'
                      : 'border-grey-300 text-neutral-200 hover:border-grey-400 dark:border-grey-600 dark:text-neutral-100'
                )}
              >
                {rating}
              </button>
            );
          })}
        </div>

        <div className="flex justify-between">
          <span className="text-grey-500 text-xs">Not likely</span>
          <span className="text-grey-500 text-xs">Very likely</span>
        </div>
      </div>

      <Button
        type="button"
        disabled={selectedRating === null || isSubmitting}
        isLoading={isSubmitting}
        loadingText={loadingText}
        onClick={handleSubmit}
        variant="pink"
        size="lg"
      >
        <p>Continue</p>
      </Button>
    </div>
  );
}
